export const copyToolHistorySelector = (state) => state.copyTool.history;
export const copyToolRollbackSelector = (state) => state.copyTool.rollback;
